import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { mapGetters, mapState } from 'vuex';
import { VueTelInputVuetify } from 'vue-tel-input-vuetify';
import ToggleSwitch from '~/components/settings/ToggleSwitch.vue';
export default {
  name: "ClientUsersSettings",
  components: {
    VueTelInputVuetify: VueTelInputVuetify,
    ToggleSwitch: ToggleSwitch
  },
  props: {},
  data: function data() {
    var _this = this;
    return {
      newClientUserModal: false,
      loadingNewUser: false,
      panel: undefined,
      newUser: {},
      confirmCreateUserModal: false,
      currentUserID: null,
      genders: ["F", "M"].map(function (gender) {
        return {
          text: _this.$t("components.genders.".concat(gender.toLocaleLowerCase())),
          value: gender
        };
      })
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters({
    users: "userManager/usersList",
    userLimit: "userManager/userLimit",
    absenceFeature: "userManager/hasAbsenceManagementFeature"
  })), mapState({
    usersInfo: function usersInfo(state) {
      return state.settings.me.users;
    },
    loading: function loading(state) {
      return state.userManager.loading;
    },
    error: function error(state) {
      return state.userManager.error;
    },
    sendPasswordStatus: function sendPasswordStatus(state) {
      return state.userManager.sendPasswordStatus;
    },
    userType: function userType(state) {
      return state.formData.settings.client_roles_names;
    },
    userManagerFilter: function userManagerFilter(state) {
      return state.userManager.filter;
    },
    canResetPassword: function canResetPassword(state) {
      return state.settings.me.security.can_reset_password;
    }
  })), {}, {
    langLocales: function langLocales() {
      return this.$helpers.languagesLocales();
    },
    isMaster: function isMaster() {
      return this.$store.getters["permissions/userIsMaster"];
    }
  }),
  watch: {
    'newUser.last_name': {
      deep: false,
      handler: function handler(newValue, oldValue) {
        this.newUser.last_name = !!newValue && newValue !== oldValue ? newValue.toUpperCase() : "";
      }
    }
  },
  created: function created() {
    this.$store.dispatch("userManager/getUsers");
  },
  methods: {
    closeModal: function closeModal(_ref) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _ref$resetValue, resetValue;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _ref$resetValue = _ref.resetValue, resetValue = _ref$resetValue === void 0 ? false : _ref$resetValue;
              _context.next = 3;
              return _this2.$refs.newClientUserObs.reset();
            case 3:
              _this2.newClientUserModal = false;
              !!resetValue && (_this2.newUser = {});
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openModal: function openModal() {
      this.newClientUserModal = true;
    },
    uppercase: function uppercase(event) {
      event.target.value = event.target.value.toUpperCase();
    },
    closeConfirmDelModal: function closeConfirmDelModal() {
      this.confirmCreateUserModal = false;
    },
    openConfirmDelModal: function openConfirmDelModal() {
      if (this.userLimit) {
        this.confirmCreateUserModal = true;
      } else {
        this.validNewUser();
      }
    },
    validNewUser: function validNewUser() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this3$$refs, _this3$$refs$newClien;
        var newClientUserIsValide;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3 === null || _this3 === void 0 ? void 0 : (_this3$$refs = _this3.$refs) === null || _this3$$refs === void 0 ? void 0 : (_this3$$refs$newClien = _this3$$refs.newClientUserObs) === null || _this3$$refs$newClien === void 0 ? void 0 : _this3$$refs$newClien.validate();
            case 2:
              newClientUserIsValide = _context2.sent;
              _context2.t0 = !!newClientUserIsValide && !_this3.loadingNewUser;
              if (!_context2.t0) {
                _context2.next = 7;
                break;
              }
              _context2.next = 7;
              return _this3.createNewUser();
            case 7:
              _this3.closeConfirmDelModal();
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    emitEvents: function emitEvents(event) {
      this.$store.commit("userManager/setfilterActiveUsers", event);
    },
    createNewUser: function createNewUser() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.loadingNewUser = true;
              _context3.next = 3;
              return _this4.$store.dispatch("userManager/createNewUser", {
                user: _this4.newUser,
                callbackSuccess: _this4.newUserCallbackSuccess,
                callbackError: _this4.newUserCallbackError
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    sendPassword: function sendPassword(user) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this5.$store.dispatch("userManager/sendPassword", {
                email: user.email
              });
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    telInputChange: function telInputChange(value, payload, _ref2) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var international, isValid, country;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              international = _ref2.number.international, isValid = _ref2.isValid, country = _ref2.country;
              if (isValid) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return");
            case 3:
              _context5.next = 5;
              return _this6.$store.commit("userManager/setUser", {
                index: payload.index,
                key: "phone",
                value: international
              });
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    inputBlur: function inputBlur(event, payload) {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _event$target;
        var value;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              value = (event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) || "";
              _context6.next = 3;
              return _this7.$store.commit("userManager/setUser", {
                index: payload.index,
                key: payload.key,
                value: value
              });
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    inputChange: function inputChange(newValue, payload) {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.t0 = !!newValue;
              if (!_context7.t0) {
                _context7.next = 4;
                break;
              }
              _context7.next = 4;
              return _this8.$store.commit("userManager/setUser", {
                index: payload.index,
                key: payload.key,
                value: newValue
              });
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    inputSwitch: function inputSwitch(newValue, payload) {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this9.$store.commit("userManager/setUser", {
                index: payload.index,
                key: payload.key,
                value: !!newValue
              });
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    switchAndSave: function switchAndSave(event, payload) {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!(_this10.userManagerFilter !== 0)) {
                _context9.next = 5;
                break;
              }
              _context9.next = 3;
              return _this10.updateUser(_objectSpread(_objectSpread({}, _this10.users[payload.index]), {}, _defineProperty({}, payload.key, !!event)));
            case 3:
              _context9.next = 7;
              break;
            case 5:
              _context9.next = 7;
              return _this10.inputSwitch(event, payload);
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    updateUser: function updateUser(user) {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var _this11$$refs$;
        var clientUserIsValide;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _this11 === null || _this11 === void 0 ? void 0 : (_this11$$refs$ = _this11.$refs["clientUserObs_".concat(user.id)][0]) === null || _this11$$refs$ === void 0 ? void 0 : _this11$$refs$.validate();
            case 2:
              clientUserIsValide = _context10.sent;
              _this11.currentUserID = user.id;
              _context10.t0 = !!clientUserIsValide;
              if (!_context10.t0) {
                _context10.next = 8;
                break;
              }
              _context10.next = 8;
              return _this11.$store.dispatch("userManager/updateUser", {
                user: user,
                callbackSuccess: _this11.updateUserCallbackSuccess,
                callbackError: _this11.updateUserCallbackError
              });
            case 8:
              _context10.t1 = !!_this11.userIsCurrent(user);
              if (!_context10.t1) {
                _context10.next = 12;
                break;
              }
              _context10.next = 12;
              return _this11.changeLanguage(_objectSpread({}, user));
            case 12:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    newUserCallbackSuccess: function newUserCallbackSuccess() {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this12.closeModal({
                resetValue: true
              });
            case 2:
              _context11.next = 4;
              return _this12.$store.dispatch("userManager/getUsers");
            case 4:
              _context11.next = 6;
              return _this12.$store.dispatch("settings/getMe");
            case 6:
              _this12.loadingNewUser = false;
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    newUserCallbackError: function newUserCallbackError(error) {
      var _this$$refs;
      var data = error === null || error === void 0 ? void 0 : error.data;
      !!data && this.setErrors(this === null || this === void 0 ? void 0 : (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.newClientUserObs, data);
      this.loadingNewUser = false;
    },
    updateUserCallbackSuccess: function updateUserCallbackSuccess() {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var _this13$$auth$user;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this13.panel = null;
              _context12.next = 3;
              return _this13.$store.dispatch("userManager/getUsers", {
                displayError: false
              });
            case 3:
              if (_this13.$store.state.userManager.error) {
                _context12.next = 8;
                break;
              }
              _context12.next = 6;
              return _this13.$store.dispatch("settings/getMe");
            case 6:
              _context12.next = 17;
              break;
            case 8:
              _context12.prev = 8;
              _context12.next = 11;
              return _this13.$auth.fetchUser();
            case 11:
              if (!!((_this13$$auth$user = _this13.$auth.user) !== null && _this13$$auth$user !== void 0 && _this13$$auth$user.companies)) {
                _this13.$store.commit("companies/setUserCompanies", _this13.$auth.user.companies);
                _this13.$router.push({
                  name: "settings"
                }, function () {
                  _this13.$router.go(0);
                });
              }
              _context12.next = 17;
              break;
            case 14:
              _context12.prev = 14;
              _context12.t0 = _context12["catch"](8);
              console.error(_context12.t0);
            case 17:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[8, 14]]);
      }))();
    },
    updateUserCallbackError: function updateUserCallbackError(error) {
      var data = error === null || error === void 0 ? void 0 : error.data;
      !!data && this.setErrors(this === null || this === void 0 ? void 0 : this.$refs["clientUserObs_".concat(this.currentUserID)][0], data);
    },
    setErrors: function setErrors(ref, err) {
      ref === null || ref === void 0 ? void 0 : ref.setErrors(err);
    },
    userIsCurrent: function userIsCurrent(user) {
      if (user.role !== "Master") {
        return null;
      }
      if (user.email !== this.$auth.user.email) {
        return null;
      }
      return true;
    },
    changeLanguage: function changeLanguage(_ref3) {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var lang;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              lang = _ref3.lang;
              if (!(lang === _this14.$i18n.locale)) {
                _context13.next = 3;
                break;
              }
              return _context13.abrupt("return", null);
            case 3:
              _context13.next = 5;
              return _this14.$helpers.changeLanguage({
                lang: lang
              });
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    exportList: function exportList() {
      var _this15 = this;
      var status = this.$store.getters["userManager/filterActiveUsers"];
      this.$api.client.exportUsersList(status).then(function (res) {
        var filename = !!res.headers.get("content-filename") ? res.headers.get("content-filename") : "users.xlsx";
        _this15.$helpers.FileSaver.saveAs(new Blob([res._data]), filename);
      }).catch(function () {
        _this15.$flashMessage.error({
          title: "<".concat(_this15.$options.name, "> : ").concat(_this15.$t("messages.error")),
          message: _this15.$t("messages.cant_get_document")
        });
      });
    }
  }
};